package org.zest.insan_360_website.pages.user

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.rememberCoroutineScope
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.selectors.active
import com.varabyte.kobweb.silk.style.selectors.hover
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.s
import org.zest.insan_360_website.components.layouts.userPageBGColor
import org.zest.insan_360_website.components.layouts.userPageBorderStrongColor
import org.zest.insan_360_website.components.layouts.userPageCardColor
import org.zest.insan_360_website.data.page_states.AuthState
import org.zest.insan_360_website.data.page_states.dashboard.ReportDashPageState.fetchReportTemplates
import org.zest.insan_360_website.data.page_states.dashboard.ReportDashPageState.fetchSubmissionHistory
import org.zest.insan_360_website.data.page_states.dashboard.ReportDashPageState.fetchTestUsers
import org.zest.insan_360_website.data.page_states.dashboard.ReportDashPageState.needToFetch
import org.zest.insan_360_website.model.UserRole
import org.zest.insan_360_website.pages.user.report_layout.AdminLayout
import org.zest.insan_360_website.pages.user.report_layout.StudentLayout
import org.zest.insan_360_website.pages.user.report_layout.SuperAdminLayout

val reportSectionButtonStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .textAlign(TextAlign.Center)
            .fontSize(0.5.cssRem)
            .fontWeight(FontWeight.Medium)
            .backgroundColor(userPageCardColor)
            .padding(leftRight = 0.75.cssRem, topBottom = 0.5.cssRem)
            .borderRadius(0.5.cssRem)
            .border {
                width(1.px)
                color(userPageBorderStrongColor)
                style(LineStyle.Solid)
            }
            .cursor(Cursor.Pointer)
            .transition {
                property("background-color")
                duration(0.25.s)
            }
    }

    hover {
        Modifier.backgroundColor(userPageCardColor.darkened(0.1f))
    }

    active {
        Modifier.backgroundColor(userPageCardColor.darkened(0.2f))
    }

    cssRule(":hover .content-button-text") {
        Modifier.color(userPageBGColor)
    }
}

@Page
@Layout(".components.layouts.UserDashboardLayout")
@Composable
fun UserReportPage() {
    val scope = rememberCoroutineScope()

    LaunchedEffect(Unit) {
        if (AuthState.role != UserRole.STUDENT) {
            fetchReportTemplates(scope)
        }
        if (AuthState.role == UserRole.STUDENT) {
            fetchSubmissionHistory()
        }
    }

    LaunchedEffect(needToFetch) {
        if (needToFetch) {
            fetchTestUsers(scope)
            needToFetch = false
        }
    }

    if (AuthState.role == UserRole.STUDENT) StudentLayout()
    if (AuthState.role == UserRole.ADMIN) AdminLayout()
    if (AuthState.role == UserRole.SUPER_ADMIN) SuperAdminLayout()
}
